import type { RegisterStep } from '../page';

const STEP_NAMES: Record<RegisterStep, string> = {
  role: '어떤 역할로 이용하시나요?',
  terms: '약관에 동의해주세요',
  info: '기본 정보를 입력해주세요',
  'patient-1': '환자 정보를 입력해주세요',
  'patient-2': '간병 조건을 입력해주세요',
  'caregiver-1': '경력 및 자격증을 입력해주세요',
  'caregiver-2': '근무 조건을 입력해주세요',
  otp: '휴대폰 인증',
  success: '가입 완료',
};

interface StepHeaderProps {
  step: RegisterStep;
  stepIndex: number;
  totalSteps: number;
  onBack: () => void;
  subtitle?: string;
}

export default function StepHeader({ step, stepIndex, totalSteps, onBack, subtitle }: StepHeaderProps) {
  return (
    <div className="mb-6">
      <button onClick={onBack} className="mb-4 text-gray-400 cursor-pointer">
        <i className="ri-arrow-left-line text-xl" />
      </button>
      <div className="flex items-center gap-2 mb-3">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <div
            key={i}
            className={`flex-1 h-1.5 rounded-full transition-all duration-300 ${
              i <= stepIndex ? 'bg-[#2E7D6B]' : 'bg-gray-200'
            }`}
          />
        ))}
      </div>
      <p className="text-xs text-gray-400 mb-1">
        {stepIndex + 1}/{totalSteps}
      </p>
      <h1 className="text-xl font-bold text-gray-900">{STEP_NAMES[step]}</h1>
      {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
    </div>
  );
}